import Toastify from 'toastify-js'

const notificationTypes = {
    success: 'success',
    error: 'error',
};

const showNotification = (type, message) => {
    if (!notificationTypes[type]) {
        console.warn(`Unknown type of notification: ${type}`);
        return;
    }

    Toastify({
        text: message,
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'center',
        className: `notification notification--${type}`
    }).showToast();
}

export const showSuccessNotification = (message) => {
    showNotification(notificationTypes.success, message);
}

export const showErrorNotification = (message) => {
    showNotification(notificationTypes.error, message);
}

